import { DrawerCloseButton, OrderVehicleReminder } from '@components';
import { useView } from '@hooks';
import { Drawer } from 'antd';
import React from 'react';

interface IProps {
  open: boolean;
  vin: string;
  registrationNumber: string;
  customerId: string;
  currentMileage: number | undefined;
  onClose: () => void;
}

/** The vehicle's service reminders, opened from the customer card - was a tab on the order. */
export const RemindersDrawer: React.FC<IProps> = ({
  open,
  vin,
  registrationNumber,
  customerId,
  currentMileage,
  onClose,
}) => {
  const { isMobile } = useView();

  return (
    <Drawer
      title="Reminders"
      open={open}
      onClose={onClose}
      styles={{ wrapper: { width: isMobile ? '100%' : 720 } }}
      destroyOnHidden
      closable={false}
      extra={<DrawerCloseButton onClick={onClose} />}
    >
      <OrderVehicleReminder
        vin={vin}
        registrationNumber={registrationNumber}
        customerId={customerId}
        currentMileage={currentMileage}
      />
    </Drawer>
  );
};
